import React from 'react';
import PropTypes from 'prop-types';
import PictionJS from 'piction-js';
import { connect } from 'react-redux';
import classNames from 'classnames';
import _ from 'lodash';
import { List } from 'immutable';
import UMOGridItemOverlay from '../UMOGridItem/UMOGridItemOverlay';
import { UMOGalleryUMODraggable } from '../../utils/draggables';
import { SearchParams } from '../../utils/searchUtils';
import UMODataFields from './UMODataFields';
import { disableRightClick } from '../../utils/uiUtils';
import SelectableComponent from '../UMOSelectableItemWrapper';

const mapStateToProps = (state) => ({
  session: state.session,
});
const mapDispatchToProps = (dispatch) => ({
  dispatch: (actionToDispatch) => dispatch(actionToDispatch),
});

function UMOListItem({
  umo,
  onDetailViewClick,
  customMetatag,
  toggleFullImageView,
  isNotJustified,
  isWorkspaceItem,
  isUMOGalleryWorkspace,
  isSelected,
  isLoaded,
  classModifier,
  overlayClassModifier,
  retrieveAlternateUMOs,
  dispatch,
  selectedWorkspaceData,
  searchParams,
  selectedUMOIDs,
  isSelectAll,
  workspaceCardsViewTimes,
  highlightSetID,
  galleryType,
  session,
  isSelectableItem,
}) {
  let url = '';
  const isRestricted =
    umo.thumbnail &&
    umo.thumbnail._data &&
    umo.thumbnail._data.$.restricted === 'T';
  const img = document.createElement('img');
  img.src = './images/images.png';
  const dragHandler = (evt) => {
    $('.main__search-bar').css('pointer-events', 'none');
    const workspaceID =
      isUMOGalleryWorkspace &&
      selectedWorkspaceData &&
      selectedWorkspaceData.id;
    const selectionData = {
      searchParams: searchParams && searchParams.toSearchQuery(),
      selectedUMOIDs,
      isSelectAll,
    };
    evt.dataTransfer.setDragImage(img, -10, -10);
    evt.dataTransfer.setData(
      'text/plain',
      new UMOGalleryUMODraggable(
        evt.target.dataset.item,
        !!workspaceID,
        workspaceID ? { workspaceID, ...selectionData } : { ...selectionData }
      ).stringify()
    );
  };
  const dragEndHandler = (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }
    $('.main__search-bar').removeAttr('style');
  };
  const dragEnterHandler = (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }
  };
  const dragOverHandler = (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }
  };
  const dropHandler = (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }
  };

  if (isRestricted) url = './images/thumb/restricted.jpg';
  else if (parseInt(umo.thumbnail._data.$.tsize) !== 0) {
    url = umo.thumbnail.url;
  } else {
    switch (umo.type) {
      case 'AUDIO':
        url = './images/thumb/audio.jpg';
        break;
      case 'DOCUMENT':
        url = './images/thumb/document.gif';
        break;
      case 'RELATIONAL':
        url = './images/thumb/relational.gif';
        break;
      case 'PHOTO':
      case 'VIDEO':
      default:
        url = './images/thumb/img_nothumb.gif';
        break;
    }
  }
  let customMeta = '';
  if (customMetatag) {
    const customTag = umo.metadataList.getMetadata(customMetatag);
    if (customTag && customTag.value) {
      customMeta = <span className={`umo-grid-item--customIcon ${customTag.value.toLowerCase()}`} />;
    }
  }
  let isUnseenUpdate = false;
  if (workspaceCardsViewTimes) {
    const updateTime = _.find(workspaceCardsViewTimes.viewtimes, {
      umo_id: parseInt(umo.id),
    });
    if (updateTime) {
      isUnseenUpdate = new Date(updateTime.viewtm).valueOf() < new Date(updateTime.cardtm).valueOf();
    }
  }

  const onAlternatesClick = (e) => {
    // todo: refactor. correct select toggle should probably be given
    retrieveAlternateUMOs(umo.id);
    e.stopPropagation();
  };
  // eslint-disable-next-line no-underscore-dangle
  const hasAlternates = umo._data.re > 1;

  const thumbWidth = umo.data.w[0];
  const thumbHeight = umo.data.h[0];
  const imageTag = (
    <img
      alt=""
      className="image"
      src={url}
      width={thumbWidth}
      height={thumbHeight}
      onContextMenu={disableRightClick}
    />
  );

  return (
    <tr className="umo-list-item__row">
      <td className="umo-list-item__row-img">
        <div
          className={classNames('umo-list-item', {
            'umo-grid-item-noj--selected': isSelected,
          })}
        >
          <div
            className={classNames(
              'umo-grid-item',
              classModifier,
              'umo-grid-item--noj',
              {
                'umo-grid-item--selected': isSelected,
                'umo-grid-item--loaded': isLoaded,
              }
            )}
            draggable={!isWorkspaceItem}
            onDrop={dropHandler}
            onDragStart={dragHandler}
            onDragEnd={dragEndHandler}
            data-item={umo.id}
            onDragEnter={dragEnterHandler}
            onDragOver={dragOverHandler}
          >
            {customMeta}
            {imageTag}
            <UMOGridItemOverlay
              onDetailViewClick={onDetailViewClick}
              toggleFullImageView={toggleFullImageView}
              overlayClassModifier={overlayClassModifier}
              isNotJustified={isNotJustified}
              isWorkspaceItem={isWorkspaceItem}
              isUMOGalleryWorkspace={isUMOGalleryWorkspace}
              isSelected={isSelected}
              dispatch={dispatch}
              umo={umo}
              selectedWorkspaceData={selectedWorkspaceData}
              isUnseenUpdate={isUnseenUpdate}
              highlightSetID={highlightSetID}
              galleryType={galleryType}
              isRestricted={isRestricted}
            />
            {hasAlternates ? (
              <span
                onClick={onAlternatesClick}
                className="umo-grid-item__overlay-alternates"
              >
                <i
                  className={classNames(
                    isSelected
                      ? 'umo-grid-item__overlay-alternates--checked'
                      : 'umo-grid-item__overlay-alternates-icon'
                  )}
                />
              </span>
            ) : null}
          </div>
          {isSelectableItem && <SelectableComponent selectableKey={umo.id} />}
          <div className="umo-list-item__media-name">{umo.name}</div>
        </div>
      </td>
      <td>
        <UMODataFields umo={umo} dispatch={dispatch} session={session} />
      </td>
    </tr>
  );
}
UMOListItem.propTypes = {
  umo: PropTypes.instanceOf(PictionJS.UMO).isRequired,
  selectedUMOIDs: PropTypes.instanceOf(List),
  customMetatag: PropTypes.string,
  searchParams: PropTypes.instanceOf(SearchParams),
  onDetailViewClick: PropTypes.func,
  toggleFullImageView: PropTypes.func,
  retrieveAlternateUMOs: PropTypes.func,
  classModifier: PropTypes.string,
  overlayClassModifier: PropTypes.string,
  isNotJustified: PropTypes.bool,
  isWorkspaceItem: PropTypes.bool,
  isUMOGalleryWorkspace: PropTypes.bool,
  isSelected: PropTypes.bool,
  isSelectAll: PropTypes.bool,
  isLoaded: PropTypes.bool,
  dispatch: PropTypes.func,
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  workspaceCardsViewTimes: PropTypes.shape({
    catid: PropTypes.string,
    usernm: PropTypes.string,
    viewtimes: PropTypes.array,
  }),
  highlightSetID: PropTypes.string,
  galleryType: PropTypes.string,
  isSelectableItem: PropTypes.bool,
};
export default connect(mapStateToProps, mapDispatchToProps)(UMOListItem);
